import { render, staticRenderFns } from "./SoilMapImportSettings.vue?vue&type=template&id=cdd2ed50&scoped=true&lang=html&"
import script from "./SoilMapImportSettings.vue?vue&type=script&lang=js&"
export * from "./SoilMapImportSettings.vue?vue&type=script&lang=js&"
import style0 from "./SoilMapImportSettings.vue?vue&type=style&index=0&id=cdd2ed50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdd2ed50",
  null
  
)

export default component.exports